import { render, staticRenderFns } from "./ButtonBadge.vue?vue&type=template&id=5c8912ef&scoped=true&"
import script from "./ButtonBadge.vue?vue&type=script&lang=js&"
export * from "./ButtonBadge.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBadge.vue?vue&type=style&index=0&id=5c8912ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8912ef",
  null
  
)

export default component.exports